import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Row, Col, Typography, Button } from "antd";
import { css } from "@emotion/css";
import { getCheckOutAction } from "../../../../store/action/admin/checkOutActions";
import { getCheckInAction } from "../../../../store/action/admin/checkInActions";
import ArrowCircle from "../../../../Theme/CustomIcons/Icons/Arrow/ArrowCircleDownIcon";
import CustomLoaderIcon from "../../../../Theme/CustomIcons/Icons/Essetional/CustomLoaderIcon.js";
import { useNavigate } from "react-router-dom";
const { Title, Text } = Typography;

const MyColleagues = () => {
  const dispatch = useDispatch();
  const [showAll, setShowAll] = useState(false);
  const INITIAL_DISPLAY_COUNT = 5;
  const navigate = useNavigate();
  const { notifications: checkOutNotifications, loading: checkOutLoading } =
    useSelector((state) => state.checkOut);
  const { notifications: checkInNotifications, loading: checkInLoading } =
    useSelector((state) => state.checkIn);
  const themeDefault = useSelector((state) => state.themeDefault);
  const isDefaultTheme = themeDefault?.info?.themeColor === "default";
  const isLoading = checkOutLoading || checkInLoading;

  useEffect(() => {
    dispatch(getCheckOutAction());
    dispatch(getCheckInAction());
  }, [dispatch]);

  const formatTime = (timeString) => {
    if (!timeString) return "";

    if (timeString.includes(":") && !timeString.includes(" ")) {
      const [hours, minutes] = timeString.split(":");
      const hour = parseInt(hours);
      const suffix = hour >= 12 ? "pm" : "am";
      const formattedHour = hour % 12 || 12;
      return `${formattedHour}:${minutes}${suffix}`;
    }

    if (timeString.includes("T")) {
      const time = timeString.split("T")[1].substring(0, 5);
      const [hours, minutes] = time.split(":");
      const hour = parseInt(hours);
      const suffix = hour >= 12 ? "pm" : "am";
      const formattedHour = hour % 12 || 12;
      return `${formattedHour}:${minutes}${suffix}`;
    }

    if (timeString.includes(" ")) {
      const time = timeString.split(" ")[1].substring(0, 5);
      const [hours, minutes] = time.split(":");
      const hour = parseInt(hours);
      const suffix = hour >= 12 ? "pm" : "am";
      const formattedHour = hour % 12 || 12;
      return `${formattedHour}:${minutes}${suffix}`;
    }

    return timeString;
  };

  const checkInArray = Array.isArray(checkInNotifications)
    ? checkInNotifications
    : checkInNotifications?.userCheckIn
    ? [checkInNotifications.userCheckIn]
    : [];

  const checkOutArray = Array.isArray(checkOutNotifications)
    ? checkOutNotifications
    : [];

  const displayedCheckIns = showAll
    ? checkInArray
    : checkInArray.slice(0, INITIAL_DISPLAY_COUNT);

  const displayedCheckOuts = showAll
    ? checkOutArray
    : checkOutArray.slice(0, INITIAL_DISPLAY_COUNT);

  const hasMoreItems =
    checkInArray.length > INITIAL_DISPLAY_COUNT ||
    checkOutArray.length > INITIAL_DISPLAY_COUNT;

  const styles = {
    columnContainer: css`
      display: flex;
      flex-direction: column;
      height: 100%;
    `,
    header: css`
      padding-bottom: 10px;
    `,
    scrollableContent: css`
      overflow-y: auto;
      flex-grow: 1;
      max-height: ${hasMoreItems ? "160px" : "210px"};
      margin-right: -8px;
      padding-right: 8px;

      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
      }
      &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 4px;
      }
    `,
    userItem: css`
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;
      width: 100%;

      @media (max-width: 1300px) {
        flex-direction: column;
        align-items: flex-start;
        margin-bottom: 2px;
      }
    `,
    userInfo: css`
      display: flex;
      align-items: center;
      gap: 8px;

      @media (max-width: 1300px) {
        margin-bottom: 2px;
        width: 100%;
      }
    `,
    time: css`
      font-size: 10px !important;
      color: ${isDefaultTheme ? "#230D39" : "white"};
      font-weight: 500;
      white-space: nowrap;

      @media (max-width: 1300px) {
        padding-left: 32px;
        font-size: 10px;
        display: block;
        width: 100%;
      }
    `,
    name: css`
      font-size: 10px !important;
      color: #9c92a6;
      font-weight: 700 !important;

      @media (max-width: 700px) {
        white-space: nowrap;
      }
    `,
    cardContent: css`
      display: flex;
      flex-direction: column;
      height: 100%;
    `,
    loaderContainer: css`
      display: flex;
      justify-content: center;
      align-items: center;
      height: 250px;
      width: 100%;
    `,
    userImage: css`
      width: 24px;
      height: 24px;
      border-radius: 50%;
      object-fit: cover;
    `,
  };

  return (
    <Col xs={24}>
      <Card
        title="My Colleagues"
        className={css`
          width: 100%;
          max-width: 480px;
          height: 334px;
          display: flex;
          flex-direction: column;
        `}
      >
        {isLoading ? (
          <div className={styles.loaderContainer}>
            <CustomLoaderIcon size="medium" color="black" />
          </div>
        ) : (
          <div className={styles.cardContent}>
            <Row gutter={[16, 16]} style={{ height: "100%" }}>
              {/* Check-in Column */}
              <Col span={12} className={styles.columnContainer}>
                <div className={styles.header}>
                  <Title
                    className={css`
                      font-size: 14px !important;
                      color: #9c92a6 !important;
                      margin-bottom: 0 !important;
                    `}
                    level={5}
                  >
                    Check-in
                  </Title>
                </div>
                <div className={styles.scrollableContent}>
                  {displayedCheckIns.length > 0 ? (
                    displayedCheckIns.map((item, index) => (
                      <div key={index} className={styles.userItem}>
                        <div className={styles.userInfo}>
                          <img
                            src={
                              item.userId?.profileImage?.url ||
                              item.profileImage?.url ||
                              "https://i.redd.it/5el4aenqzg061.jpg"
                            }
                            alt="User"
                            className={styles.userImage}
                          />
                          <Text className={styles.name}>
                            {item.userId?.name?.firstName ||
                              item.name?.firstName ||
                              ""}{" "}
                            {item.userId?.name?.lastName ||
                              item.name?.lastName ||
                              ""}
                          </Text>
                        </div>
                        <Text className={styles.time}>
                          {formatTime(item.startTime)}
                        </Text>
                      </div>
                    ))
                  ) : (
                    <Text>No check-ins available</Text>
                  )}
                </div>
              </Col>

              {/* Check-out Column */}
              <Col span={12} className={styles.columnContainer}>
                <div className={styles.header}>
                  <Title
                    className={css`
                      font-size: 14px !important;
                      color: #9c92a6 !important;
                      margin-bottom: 0 !important;
                    `}
                    level={5}
                  >
                    Check-out
                  </Title>
                </div>
                <div className={styles.scrollableContent}>
                  {displayedCheckOuts.length > 0 ? (
                    displayedCheckOuts.map((item, index) => (
                      <div key={index} className={styles.userItem}>
                        <div className={styles.userInfo}>
                          <img
                            src={
                              item.userId?.profileImage?.url ||
                              "https://i.redd.it/5el4aenqzg061.jpg"
                            }
                            alt="User"
                            className={styles.userImage}
                          />
                          <Text className={styles.name}>
                            {item.userId?.name?.firstName}{" "}
                            {item.userId?.name?.lastName}
                          </Text>
                        </div>
                        <Text className={styles.time}>
                          {formatTime(item.endTime)}
                        </Text>
                      </div>
                    ))
                  ) : (
                    <Text>No check-outs available</Text>
                  )}
                </div>
              </Col>
            </Row>

            {hasMoreItems && !showAll && (
              <Button
                block
                type="link"
                onClick={() => navigate("/my-colleagues-check")}
                className={css`
                  &.ant-btn {
                    color: ${isDefaultTheme ? "#230D39" : "white"};
                    border: none !important;
                    box-shadow: none !important;
                    font-size: 12px !important;
                    display: flex !important;
                    align-items: center !important;
                    margin-top: 16px !important;
                  }
                `}
              >
                Load more
                <ArrowCircle
                  className={css`
                    path {
                      stroke: ${isDefaultTheme ? "#230D39" : "white"};
                      fill: ${isDefaultTheme ? "#230D39" : "white"};
                    }
                    svg {
                      stroke: ${isDefaultTheme ? "#230D39" : "white"};
                      fill: ${isDefaultTheme ? "#230D39" : "white"};
                    }
                    font-size: 12px !important;
                  `}
                />
              </Button>
            )}
          </div>
        )}
      </Card>
    </Col>
  );
};

export default MyColleagues;
